import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';
// Subscriber List v2 (15 Oct 2026): one file per feature area so parallel work never edits the same file.
// slList = the list page (agent W1), slBulk = bulk/export/saved views (W2), slPop = quick preview + POP (W3).
import slListEn from './locales/sl/list.en.json';
import slListHi from './locales/sl/list.hi.json';
import slListTa from './locales/sl/list.ta.json';
import slBulkEn from './locales/sl/bulk.en.json';
import slBulkHi from './locales/sl/bulk.hi.json';
import slBulkTa from './locales/sl/bulk.ta.json';
import slPopEn from './locales/sl/pop.en.json';
import slPopHi from './locales/sl/pop.hi.json';
import slPopTa from './locales/sl/pop.ta.json';

export const supportedLanguages = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ta', label: 'Tamil', nativeLabel: 'தமிழ்', flag: '🇮🇳' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, slList: slListEn, slBulk: slBulkEn, slPop: slPopEn } },
      hi: { translation: { ...hi, slList: slListHi, slBulk: slBulkHi, slPop: slPopHi } },
      ta: { translation: { ...ta, slList: slListTa, slBulk: slBulkTa, slPop: slPopTa } },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi', 'ta'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
